import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleLocatiiActiveComponent } from './module-locatii-active.component';
import { AddModuleLocatiiActiveComponent } from './add-module-locatii-active/add-module-locatii-active.component';
import { EditModuleLocatiiActiveComponent } from './edit-module-locatii-active/edit-module-locatii-active.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        ModuleLocatiiActiveComponent,
        AddModuleLocatiiActiveComponent,
        EditModuleLocatiiActiveComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [ModuleLocatiiActiveComponent],
})
export class ModuleLocatiiActiveModule { }
